<form [formGroup]="form" class="w-100">
  <mat-card *ngIf="canModifyPosts" class="mb-3 mat-elevation-z1">
    <mat-card-content>
      <h2 class="mat-subheading-2 mb-2">Guard Posts</h2>
      <div class="d-flex justify-content-start mb-3">
        <button mat-stroked-button type="button" (click)="openAddPostDialog()">
          <mat-icon class="me-1">add</mat-icon>
          Add Post
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <div formArrayName="servicePosts" class="container-fluid px-0">
    <div *ngFor="let grp of postsFormArray.controls; let i = index; trackBy: trackBySiteIdx" [formGroupName]="i"
      class="mat-elevation-z2 mb-2 p-2 rounded">

          <ng-container *ngIf="getSiteId(grp) as sid">
            <div class="row align-items-center bg-light border rounded px-2 py-2 mx-0 mb-2">
              <div class="col">
                <ng-container *ngIf="sitesById?.get(sid) as site; else sidFallback">
                  <div class="fw-semibold">
                    {{ site.siteName || ('Site #' + sid) }}
                    <span *ngIf="isPrimarySiteId(sid)" class="ms-2 my-auto badge bg-secondary">Primary</span>
                  </div>
                  <div class="text-muted">
                    {{ site.street }}
                    <span *ngIf="site.city">, {{ site.city }}</span>
                    <span *ngIf="site.state">, {{ site.state }}</span>
                    <span *ngIf="site.division"> • {{ site.division }}</span>
                    <span *ngIf="site.region"> • {{ site.region }}</span>
                  </div>
                </ng-container>
                <ng-template #sidFallback>
                  <div class="fw-semibold">Site #{{ sid }}</div>
                </ng-template>
              </div>

              <div class="col-auto">
                <div class="d-flex align-items-center">
                  <mat-slide-toggle *ngIf="showSpecialAttention" formControlName="specialAttention"
                    labelPosition="before" class="me-2">
                    Special Attention
                  </mat-slide-toggle>
                  <button *ngIf="canModifyPosts && !isPrimarySiteId(sid)" mat-icon-button color="warn" type="button"
                    (click)="confirmRemovePost(i)" aria-label="Remove Site">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <div *ngIf="showSchedulingFields" formArrayName="shiftDetails">
            <div class="row mb-2">
              <div class="col">
                <button mat-stroked-button type="button" (click)="addWeeklyShiftDetail(i)">Add Weekly</button>
                <button mat-stroked-button type="button" class="ms-1" (click)="addMonthlyByDayShiftDetail(i)">Add
                  Monthly (By
                  Day)</button>
                <button mat-stroked-button type="button" class="ms-1" (click)="addMonthlyByDateShiftDetail(i)">Add
                  Monthly (By
                  Date)</button>
              </div>
            </div>

            <div class="row g-2">
              <div class="col-12"
                *ngFor="let row of shiftDetailsFA(i).controls; let j = index; trackBy: trackByShiftIdx">
                <shift-detail-form-row [formGroup]="row" [weeks]="weeks" [weekdays]="weekdays"
                  [refreshTick]="refreshTick" (remove)="removeShiftDetail(i, j)">
                </shift-detail-form-row>
              </div>
            </div>
          </div>
    </div>
  </div>
</form>

<ng-template #addSiteDialog>
  <h2 mat-dialog-title>Add Sites</h2>
  <mat-dialog-content>
    <ng-container *ngIf="canModifyPosts">
      <site-selector-table [sites]="selectableSites" [selectedSiteIds]="pendingSiteIds" [pageLength]="5"
        [loading]="availableSitesLoading" (selectedSiteIdsChange)="pendingSiteIds = $event"></site-selector-table>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancelAddPosts()">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="confirmAddPosts()"
      [disabled]="!pendingSiteIds?.length">
      Add
    </button>
  </mat-dialog-actions>
</ng-template>
